<p>dynamic-date works!</p>
